import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
//import { AppRoutingModule } from './app-routing.module';

import { ProjectsModule } from './Modules/Projects/projects.module'
import { RouterModule, Routes } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CookieService } from 'ng2-cookies';

// Local Services
import { Context } from './Services/context.service'
import { Api } from './Services/api.service'

//Components
import { AppComponent } from './app.component';


const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

];

@NgModule({
  declarations: [
    AppComponent 
  ],
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
    BrowserModule, FormsModule, CommonModule, ProjectsModule, HttpClientModule, BrowserAnimationsModule
  ],
  providers: [Context, Api, CookieService, HttpClient],
  bootstrap: [AppComponent]
})
export class AppModule { }
